import { render, staticRenderFns } from "./tag-discount.vue?vue&type=template&id=89cd7860&scoped=true"
var script = {}
import style0 from "./tag-discount.vue?vue&type=style&index=0&id=89cd7860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89cd7860",
  null
  
)

export default component.exports